//// Application Packages
import React, { useMemo, useEffect } from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import ButtonComponent from '../../components/conditional-components/button-component'

//// Carbon Components

//// Carbon Icons

//// Static Constants

//////// Component
const RegisteredNursingEndorsementFeeAndSummaryReportForm = ({ instance }) => {
    //////// Hooks

    //////// State

    //////// Slices
    const formsData = useSelector(selectForms)

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Pay Form Application On FLDOH Payment Portal
    const pay = (formsData) => {
        try {
            // Check For FormData
            if (formsData) {
                const baseUrl = process.env.REACT_APP_PAYMENT_BASE_URL
                const endpoint = process.env.REACT_APP_PAYMENT_ENDPOINT
                const applcId =
                    formsData?.['summary-submission-form']?.values?.applc_id
                const appSubId =
                    formsData?.['summary-submission-form']?.values?.app_sub_id
                const licId =
                    formsData?.['summary-submission-form']?.values?.lic_id

                // Check For Base URL, Endpoint, Application Id, Application Sub-Id, And License Id
                if (baseUrl && endpoint && applcId && appSubId && licId) {
                    // Combine Application Information
                    const applcInfo =
                        '?applc_id=' +
                        applcId +
                        '&app_code=ELICHT' +
                        '&lic_id=' +
                        licId +
                        '&app_sub_id=' +
                        appSubId

                    // Create And Stringify Pay Link
                    const payLink = (baseUrl + endpoint + applcInfo).toString()

                    // Check For Created Pay Link
                    if (payLink) {
                        return payLink
                    } else {
                        return null
                    }
                } else {
                    return null
                }
            } else {
                return null
            }
        } catch (err) {
            console.log('err', err)
            return null
        }
    }

    //////// Memoization
    const payment = useMemo(() => pay(formsData), [formsData])

    //////// Effects/Side Effects

    // Reload Watson Assistant Journey on Reload
    useEffect(() => {
        if (instance?.tours) {
            instance.tours.endTour()
            instance.tours.startTour(
                'Registered Nursing Endorsement Fee And Summary Report Tour'
            )
        }
        return () => {}
    }, [instance])

    //////////////// Render & Return
    return (
        <>
            <p>
                <strong>Florida Center for Nursing Donation</strong>
            </p>

            <p>
                The Florida Center for Nursing is the definitive source for
                information, research, and strategies addressing the dynamic
                nurse workforce needs in Florida. The Center conducts multiple
                annual and biennial research projects, including nurse employer
                and nursing program surveys, to provide a comprehensive look at
                Florida&apos;s nurse population. Based on this research, the
                Center projects a severe nursing shortage in Florida - a
                shortage that could have a devastating impact on healthcare
                quality and access for Florida&apos;s residents. The Florida
                Center for Nursing also uses the research it produces to address
                issues of supply and demand and utilization of scarce nurse
                workforce resources throughout the state.
            </p>

            <p>
                In addition to nurse workforce research, the Florida Center for
                Nursing aims to improve the retention and recruitment of nurses
                in Florida through funding small grants and also by collecting
                and disseminating information on best practices and innovative
                strategies for nurse retention and recruitment. Increasing
                production of new nurses alone will not resolve the shortage.
                Efforts must be taken to retain the experiential knowledge of
                our existing nurses.
            </p>

            <p>
                To learn more about Florida&apos;s nursing shortage and
                suggested solutions, for more information about the Center, and
                to understand how your contribution will be put to work, please
                visit the Center&apos;s website at:{' '}
                <a
                    href="http://www.FLCenterForNursing.org/donors"
                    target="_blank"
                    rel="noreferrer noopener"
                    aria-label="florida-center-for-nursing-donors-link"
                    type="link"
                >
                    FLCenterForNursing.org/donors
                </a>
                . The Florida Center for Nursing&apos;s operating revenues are
                derived in part from your donation. In order for the Florida
                Center for Nursing to continue its work on behalf of nurses,
                please donate by going to their web site.
            </p>

            <p>
                If payment is required, click &ldquo;Pay Now&ldquo; to proceed
                to the payment page.
            </p>

            <div className="button-group">
                <div className="button-group-item">
                    <ButtonComponent
                        payment={payment ? payment : '/'}
                        title="Pay Now"
                    />
                </div>
            </div>
        </>
    )
}

export default RegisteredNursingEndorsementFeeAndSummaryReportForm
